// extracted by mini-css-extract-plugin
export var avatarContainer = "_4q-0";
export var avatarTypingWave = "_4q-i";
export var gray = "_4q-f";
export var green = "_4q-c";
export var icon = "_4q-9";
export var image = "_4q-1";
export var lg = "_4q-6";
export var md = "_4q-5";
export var presenceDot = "_4q-b";
export var red = "_4q-d";
export var sm = "_4q-4";
export var status = "_4q-a";
export var typingDot = "_4q-h";
export var typingPill = "_4q-g";
export var xl = "_4q-7";
export var xs = "_4q-3";
export var xxl = "_4q-8";
export var xxs = "_4q-2";
export var yellow = "_4q-e";